export default function (router, store) {
  return async (to, from, next) => {
    next()
  }
}
